<template>
  <div class="domain_experts flex_1">
    <div class="experts_list" v-if="list.length > 0">
      <el-carousel
        ref="carouselRef"
        :interval="4000"
        type="card"
        height="250px"
        indicator-position="none"
        :autoplay="false"
        arrow="never"
      >
        <el-carousel-item
          v-for="(item, index) in list"
          :key="index"
          class="my_card"
        >
          <div class="experts_list_item h_100 flex flex_col align_items_ctr">
            <div class="cover flex" @click="$goDetail(item)">
              <img
                v-lazy="
                  item.cover
                    ? `/apis/${item.cover}`
                    : require('../../../assets/imgs/placeholder/no_person.png')
                "
                alt=""
              />
            </div>
            <div class="experts_name fw" @click="$goDetail(item)">
              {{ item.title }}
            </div>
            <div class="experts_intro text_overflow3" :title="item.abstract">
              {{ item.abstract }}
            </div>
          </div>
        </el-carousel-item>
      </el-carousel>
    </div>
    <img
      v-else
      style="height: 254px; margin: 0 auto"
      src="../../../assets/imgs/placeholder/no_data.png"
      alt=""
    />
    <img
      class="pre pointer"
      src="../../../assets/imgs/home/pre.png"
      alt=""
      @click="changeBannerClick('pre')"
    />
    <img
      class="next pointer"
      src="../../../assets/imgs/home/pre.png"
      alt=""
      @click="changeBannerClick('next')"
    />
  </div>
</template>

<script>
export default {
  name: "WorkspaceJsonYyzj",
  props: ["list"],
  data() {
    return {
      expertList: [
        {
          person_img: "",
          person_name: "王宏远",
          abstract:
            "医药技术开发、技术咨询、技术服务、技术转让；销售化工产品（不含危险化学品及一类易制毒化学品）、包装制品、仪器仪表；货物进出口、代理进出口、技术进出口。（企业依法自主选择经营项",
        },
        {
          person_img: "",
          person_name: "王宏远",
          abstract:
            "医药技术开发、技术咨询、技术服务、技术转让；销售化工产品（不含危险化学品及一类易制毒化学品）、包装制品、仪器仪表；货物进出口、代理进出口、技术进出口。（企业依法自主选择经营项",
        },
        {
          person_img: "",
          person_name: "王宏远",
          abstract:
            "医药技术开发、技术咨询、技术服务、技术转让；销售化工产品（不含危险化学品及一类易制毒化学品）、包装制品、仪器仪表；货物进出口、代理进出口、技术进出口。（企业依法自主选择经营项",
        },
        {
          person_img: "",
          person_name: "王宏远",
          abstract:
            "医药技术开发、技术咨询、技术服务、技术转让；销售化工产品（不含危险化学品及一类易制毒化学品）、包装制品、仪器仪表；货物进出口、代理进出口、技术进出口。（企业依法自主选择经营项",
        },
        {
          person_img: "",
          person_name: "王宏远",
          abstract:
            "医药技术开发、技术咨询、技术服务、技术转让；销售化工产品（不含危险化学品及一类易制毒化学品）、包装制品、仪器仪表；货物进出口、代理进出口、技术进出口。（企业依法自主选择经营项",
        },
      ],
    };
  },

  mounted() {},

  methods: {
    changeBannerClick(type) {
      if (type == "pre") {
        this.$refs.carouselRef.prev();
      }
      if (type == "next") {
        this.$refs.carouselRef.next();
      }
    },
  },
};
</script>
<style lang="less" scoped>
.domain_experts {
  width: 70%;
  margin: 0 auto;
  position: relative;

  .experts_list {
    /deep/.el-carousel__item.is-active {
      // height: 345px;
      margin-top: 5px;
    }

    /deep/.el-carousel__item {
      // width: 300px !important;
      // box-shadow: 5px 5px 10px #ccc;
      // background-color: #faf8f8 !important;
      border-radius: 10px;
      // width: 190px;
      height: 240px;
    }

    .experts_list_item {
      padding: 16px;
      word-break: break-all;

      .cover {
        width: 100px;
        height: 100px;
        border-radius: 50%;
        overflow: hidden;
        border: 1px solid #ccc;

        > img {
          margin: auto;
          max-width: 100%;
          max-height: 100%;
        }
      }

      .experts_name {
        margin: 10px 0;
        color: #1d4a77;
        &:hover {
          color: #bc1b1b;
        }
      }

      .experts_intro {
        line-height: 1.5;
        font-size: 14px;
        color: #848998;
      }
    }
  }
  .pre,
  .next {
    position: absolute;
    top: 50%;
  }
  .pre {
    left: 0;
    transform: translateX(-100px) translateY(-50%);
  }
  .next {
    right: 0;
    transform: translateX(100px) translateY(-50%) rotate(180deg);
  }
}
</style>